import React from 'react';
import {Route, Switch, Redirect, withRouter } from 'react-router-dom'
import Header from "layout/header"
import Footer from "layout/footer"
import {mkLoadable} from './util'
import GA from 'react-ga'
import MessageBanner from 'components/static/message-banner'
import Prompts from 'components/static/Prompts'
import BottomWarning from 'layout/BottomWarning'

const Body = (props) => {
  return(
    <div style={{backgroundColor: 'white'}}>
      <MessageBanner />
      <Prompts />
      <Header location={props.location}/>
      <div id="banner" />
      <Route component={logView}/>
      <Route component={BottomWarning}/>
      <Switch>
        <Route exact path='/' component={HomePage}/>
        <Route exact path='/my-digital-ballot/' component={DigitalBallotPage}/>
        <Route exact path='/election/ca-prop-1/:userId?' component={Prop1}/>
        <Route exact path='/election/ca-prop-2/:userId?' component={Prop2}/>
        <Route exact path='/election/ca-prop-3/:userId?' component={Prop3}/>
        <Route exact path='/election/ca-prop-4/:userId?' component={Prop4}/>
        <Route exact path='/election/ca-prop-5/:userId?' component={Prop5}/>
        <Route exact path='/election/ca-prop-6/:userId?' component={Prop6}/>
        <Route exact path='/election/ca-prop-7/:userId?' component={Prop7}/>
        <Route exact path='/election/ca-prop-8/:userId?' component={Prop8}/>
        <Route exact path='/election/ca-prop-9/:userId?' component={Prop9}/>
        <Route exact path='/election/ca-prop-10/:userId?' component={Prop10}/>
        <Route exact path='/election/ca-prop-11/:userId?' component={Prop11}/>
        <Route exact path='/election/ca-prop-12/:userId?' component={Prop12}/>
        <Route exact path='/election/sf-prop-a/:userId?' component={PropA}/>
        <Route exact path='/election/sf-prop-b/:userId?' component={PropB}/>
        <Route exact path='/election/sf-prop-c/:userId?' component={PropC}/>
        <Route exact path='/election/sf-prop-d/:userId?' component={PropD}/>
        <Route exact path='/election/sf-prop-e/:userId?' component={PropE}/>
        <Route exact path='/election/sj-measure-s/:userId?' component={MeasureS}/>
        <Route exact path='/election/sj-measure-t/:userId?' component={MeasureT}/>
        <Route exact path='/election/sj-measure-u/:userId?' component={MeasureU}/>
        <Route exact path='/election/sj-measure-v/:userId?' component={MeasureV}/>
        {/* <Route path='/election/:pageId/:userId?' component={ElectionRoutes}/> */}
        {/* <Route exact path='/election/' component={GeneralElectionPage}/> */}
        <Route exact path='/ballot-preview/' component={ElectionPreviewPage}/>
        <Route exact path='/print/' component={PrintGuidePage}/>
        <Route exact path='/all-components/' component={AllComponentsPage}/>
        <Route path='/wtf/' component={AboutPage}/>
        <Redirect from="/about/" to="/wtf/"/>
        <Route path='/about/' component={AboutPage}/>
        <Route path='/how-sf-works/' component={HowSFWorksPage}/>
        <Route path='/contribute/' component={DonatePage}/>
        <Route path='/support-us/' component={HelpOutPage}/>
        <Route path='/housing-shortage/' component={AffordableHousingPage}/>
        <Route path='/terms/' component={TermsPage}/>
        <Route path='/subscribe/' component={SubscribePage}/>
        <Route path='/privacy/' component={PrivacyPage}/>
        <Route path='/procrastinators/' component={ProcrastinatorsPage}/>
        <Route path='/community-values/' component={CommunityPage}/>
        <Route path='/find-your-district/' component={SupervisorMapPage}/>
        <Redirect exact from="/ballot/" to="/my-digital-ballot/"/>
        <Redirect from='/halp/' to="/support-us/"/>
        {/* <Route path='/search-results/' component={SearchResultsPage}/> */}
        <Route component={Page404}/>
      </Switch>
      <Footer />
    </div>
    )
};

// <Route exact path='/ballot/:userId?' component={BallotPage} />
// <Route exact path='/user/' component={UserPage} />
// <Route exact path='/user/login/' component={UserLoginPage} />
// <Route exact path='/user/logout/' component={UserLogoutPage} />
// <Route exact path='/user/register/' component={UserRegisterPage} />
// <Route exact path='/user/verify/' component={UserVerificationPage}/>
// <Route exact path='/user/forgot/' component={UserForgotPage} />
// <Route exact path='/user/reset-password/' component={UserResetPasswordPage} />
const HomePage = mkLoadable(import("pages/home/index"));
const Prop1 = mkLoadable(import("pages/nov-6/1/index"));
const Prop2 = mkLoadable(import("pages/nov-6/2/index"));
const Prop3 = mkLoadable(import("pages/nov-6/3/index"));
const Prop4 = mkLoadable(import("pages/nov-6/4/index"));
const Prop5 = mkLoadable(import("pages/nov-6/5/index"));
const Prop6 = mkLoadable(import("pages/nov-6/6/index"));
const Prop7 = mkLoadable(import("pages/nov-6/7/index"));
const Prop8 = mkLoadable(import("pages/nov-6/8/index"));
const Prop9 = mkLoadable(import("pages/nov-6/9/index"));
const Prop10 = mkLoadable(import("pages/nov-6/10/index"));
const Prop11 = mkLoadable(import("pages/nov-6/11/index"));
const Prop12 = mkLoadable(import("pages/nov-6/12/index"));
const PropA = mkLoadable(import("pages/nov-6/A/index"));
const PropB = mkLoadable(import("pages/nov-6/B/index"));
const PropC = mkLoadable(import("pages/nov-6/C/index"));
const PropD = mkLoadable(import("pages/nov-6/D/index"));
const PropE = mkLoadable(import("pages/nov-6/E/index"));
const ProcrastinatorsPage = mkLoadable(import("pages/procrastinators/index"));
const MeasureS = mkLoadable(import("pages/nov-6/S/index"));
const MeasureT = mkLoadable(import("pages/nov-6/T/index"));
const MeasureU = mkLoadable(import("pages/nov-6/U/index"));
const MeasureV = mkLoadable(import("pages/nov-6/V/index"));
const PrintGuidePage = mkLoadable(import("pages/print/index"));
const SupervisorMapPage = mkLoadable(import("pages/supervisor-map/SupervisorMapPage"));
const ElectionPreviewPage = mkLoadable(import("pages/nov-6/preview/PreviewPage"));
const AllComponentsPage = mkLoadable(import("pages/nov-6/AllComponentsPage"));
const DigitalBallotPage = mkLoadable(import("pages/digital-ballot/index"));
// const UserPage = mkLoadable(import("pages/user/UserPage"));
const BallotPage = mkLoadable(import("pages/ballot/BallotPage"));
// const UserLoginPage = mkLoadable(import("pages/user/UserLoginPage"));
// const UserLogoutPage = mkLoadable(import("pages/user/UserLogoutPage"));
// const UserRegisterPage = mkLoadable(import("pages/user/UserRegisterPage"));
// const UserVerificationPage = mkLoadable(import("pages/user/UserVerificationPage"));
// const UserForgotPage = mkLoadable(import("pages/user/UserForgotPage"));
// const UserResetPasswordPage = mkLoadable(import("pages/user/UserResetPasswordPage"));
const AboutPage = mkLoadable(import("pages/about/AboutPage"));
const HowSFWorksPage = mkLoadable(import("pages/how-sf-works/HowSFWorksPage"));
const AffordableHousingPage = mkLoadable(import("pages/affordable-housing/AffordableHousingPage"));
const TermsPage = mkLoadable(import("pages/terms/page"));
// const BoardPage = mkLoadable(import("pages/bos/BoardPage"));
const HelpOutPage = mkLoadable(import("pages/halp/page"));
const DonatePage = mkLoadable(import("pages/donate/DonatePage"));
const PrivacyPage = mkLoadable(import("pages/privacy/page"));
const CommunityPage = mkLoadable(import("pages/community/page"));
const SubscribePage = mkLoadable(import("pages/subscribe/SubscribePage"));
const Page404 = mkLoadable(import("pages/404/404"));
// const SearchResultsPage = mkLoadable(import("pages/search/SearchResultsPage"));

try {
  GA.initialize([
    {
      trackingId: 'UA-105777983-1',
    },
  ]);
} catch(e) {
  console.error("GA initialize error:", e.message);
}

const logView = () => {
  if(process.env.NODE_ENV === 'production' && navigator.userAgent !== 'ReactSnap') {
    GA.pageview(window.location.pathname + window.location.search);
  }
  return null;
}

export default withRouter(Body)



// WEBPACK FOOTER //
// ./src/body.js